







































import mixins from 'vue-typed-mixins'
import mobileTypeMixin from '@/plugins/mixins/mobileTypeMixin'
import validationMixin from '@/plugins/mixins/validationMixin'
import Openable from '@/global/viewmodels/openable'
import facturationsMixin from '../facturationsMixin'

export default mixins(mobileTypeMixin, validationMixin, facturationsMixin).extend({
    props: { dialog: Openable, mailReeditionFacture: Array },
    data() {
        return {
            formValid: false // Passera 'true' si le formulaire est rempli correctement (voir conditions).
        }
    },
    methods: {
        closeDialog() {
            this.dialog.close()
        },
        envoiReedition() {
            // @ts-ignore
            this.listeFacturesReedition = this.mailReeditionFacture
            this.demandeReeditionFacture()
            this.closeDialog()
        }
    }
})
